module.exports = __webpack_public_path__ + "static/media/mas.48728b66.svg";